/* eslint-disable react/prop-types */
import { useNavigate, useParams } from 'react-router-dom';
import { Typography, Stack, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export default function HeaderCommon({ headerName, onClose }) {
    const navigate = useNavigate();
    const { pageType } = useParams();


    const handleClick = () => {
        if (onClose) {
            onClose();
        } else {
            navigate(-1);
        }
    }
    return (
        <Stack direction='row' alignItems='center' justifyContent='space-between' sx={{ bgcolor: pageType === 'edit' ? '#3B3C78' : '#20b2aa', height: 40, mb: 2, borderRadius: '8px', marginBottom: '0.2rem' }} >
            <Stack direction='column' alignItems='flex-start' justifyContent='flex-start' spacing={1}>
                <Typography variant='body1' sx={{ fontSize: '1rem', lineHeight: '0.8rem', color: '#fff' }} style={{ marginLeft: '10px' }} >
                    {headerName}
                </Typography>
            </Stack>
            <Box flexGrow={1} />
            <IconButton onClick={handleClick} sx={{ color: '#fff' }}>
                <CloseIcon sx={{ width: '20px', height: '20px' }} />
            </IconButton>

        </Stack >
    );
}

